export default __webpack_public_path__ + "static/media/DNo.24-7.b2f44aab.jpg";